<section class="profile-card">
  <h2 class="profile-card--header">{{ title }}</h2>

  <section class="profile-card--body">
    <ng-content></ng-content>
  </section>
</section>
